export default {
  "bulk_upload_title": "Bulk Product Upload",
  "download_template": "Download Template",
  "select_excel": "Select Excel File (.xlsx)",
  "select_zip": "Select ZIP File (Images)",
  "upload_btn": "Upload Excel + Images ZIP",
  "uploading": "Uploading...",
  "excel_required": "Please select Excel (.xlsx) file.",
  "zip_required": "Please upload ZIP file containing images.",
  "supplier_missing": "Supplier not found. Please login again.",
  "branch_store_required": "Please select Branch and Store before uploading.",
  "upload_success": "{{count}} products imported successfully!",
  "upload_failed": "Upload failed: {{error}}",
  "upload_summary": "Upload Summary",
  "imported": "Imported",
  "row_error": "Row {{row}}: {{error}}",
  "choose_file": "Choose File",
"no_file_chosen": "No file chosen"
}